// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avater_avatar__kveNo","active":"avater_active__1FyWd"};